import React from "react";

const Info = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1216_15541)">
      <path d="M16 0H0V16H16V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M7.99992 14.6663C9.84085 14.6663 11.5075 13.9201 12.714 12.7137C13.9204 11.5073 14.6666 9.84061 14.6666 7.99967C14.6666 6.15874 13.9204 4.49207 12.714 3.28563C11.5075 2.0792 9.84085 1.33301 7.99992 1.33301C6.15899 1.33301 4.49232 2.0792 3.28587 3.28563C2.07945 4.49207 1.33325 6.15874 1.33325 7.99967C1.33325 9.84061 2.07945 11.5073 3.28587 12.7137C4.49232 13.9201 6.15899 14.6663 7.99992 14.6663Z"
        stroke="#333333"
        strokeWidth="1.12281"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00008 3.66699C8.46031 3.66699 8.83341 4.04009 8.83341 4.50033C8.83341 4.96056 8.46031 5.33366 8.00008 5.33366C7.53985 5.33366 7.16675 4.96056 7.16675 4.50033C7.16675 4.04009 7.53985 3.66699 8.00008 3.66699Z"
        fill="#333333"
      />
      <path
        d="M8.16667 11.3337V6.66699H7.83333H7.5"
        stroke="#333333"
        strokeWidth="1.12281"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 11.333H9.33333" stroke="#333333" strokeWidth="1.12281" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1216_15541">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default React.memo(Info);
